module.exports = __webpack_public_path__ + "static/stamping-press-2c2b272abcec4ac8927448cf407cedc5.png";